import React, { useEffect, useMemo, useState } from 'react';
import {
	RBHBox,
	RBHButton,
	RBHText,
	TagCount,
} from '../../../../../shared/components';
import textStyles from '../../../../../shared/components/rbh-text/styles';
import styleButton from '../../../../../shared/components/rbh-button/styles';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import styles from '../../components/FormAddEdit/styles';
import { MenuGroupOptionsModal } from './MenuGroupOptionsModal';
import { useDispatch } from 'react-redux';
import {
	FoodMenu,
	MenuModifierGroup,
} from '../../../../../shared/models/food-menu';
import { Item, RBHList } from '../../../../../shared/components/rbh-list';
import { Colors } from '../../../../../shared/theme';
import { ModifierGroup } from '../../../ModifierGroup/redux/modifier-group-type';
import { modifierGroupCreators } from '../../../ModifierGroup/redux/modifier-group-action';

interface MenuGroupFormProps {
	menu?: FoodMenu;
	onChange: (value: number[]) => void;
}
export const MenuGroupForm = ({ menu, onChange }: MenuGroupFormProps) => {
	const dispatch = useDispatch();
	const [openMenGroupOptionModal, setOpenMenuGroupOptionModal] =
		useState(false);
	const [activeModifierGroups, setActiveModifierGroups] = useState(
		menu?.menuModifierGroups ?? [],
	);

	const [menuGroups, setMenuGroups] = useState<ModifierGroup[]>([]);
	const listItem = useMemo(() => {
		return activeModifierGroups.map((item) => {
			const data = menuGroups.find(
				(group) => item.menuModifierGroupId === group.menuModifierGroupId,
			);
			return {
				...item,
				menuModifierItems: data?.menuModifierItems ?? [],
				id: item.menuModifierGroupId,
			};
		});
	}, [activeModifierGroups, menuGroups]);

	const handleOpenModal = () => {
		setOpenMenuGroupOptionModal(true);
	};

	const handleConfirmModal = (selected: ModifierGroup[]) => {
		const toAdded = selected.filter((item) =>
			activeModifierGroups.every(
				(grp) => grp.menuModifierGroupId !== item.menuModifierGroupId,
			),
		);

		const data: MenuModifierGroup[] = [];
		activeModifierGroups.forEach((item) => {
			if (
				selected.every(
					(sel) => sel.menuModifierGroupId !== item.menuModifierGroupId,
				)
			) {
				return;
			}

			data.push(item);
		});

		setActiveModifierGroups([...data, ...toAdded]);
		setOpenMenuGroupOptionModal(false);
	};

	useEffect(() => {
		dispatch(
			modifierGroupCreators.callAllModifierGroups((items) => {
				setMenuGroups(items);
			}),
		);
	}, []);

	useEffect(() => {
		onChange(activeModifierGroups.map(item => item.menuModifierGroupId))
	}, [activeModifierGroups]);
	return (
		<>
			<MenuGroupOptionsModal
				menuGroups={menuGroups}
				activeModifierGroups={activeModifierGroups}
				open={openMenGroupOptionModal}
				onClose={() => setOpenMenuGroupOptionModal(false)}
				onConfirm={handleConfirmModal}
			/>
			{activeModifierGroups.length === 0 ? (
				<RBHButton
					style={styleButton.buttonAddMenuDiscount}
					onClick={handleOpenModal}
				>
					<>
						<RBHBox style={styles.inlineBlock}>
							<PlusOutlined style={styles.iconPlus} translate={null} />
						</RBHBox>
						<RBHBox style={styles.inlineBlock}>
							<RBHText
								style={textStyles.textDarkOrchid}
								text='main.foodmenu.addmenu.modifiergroups.button'
							/>
						</RBHBox>
					</>
				</RBHButton>
			) : (
				<RBHBox
					style={{
						padding: '16px',
						border: `1px solid ${Colors.grey100}`,
						borderRadius: '16px',
						display: 'flex',
						flexDirection: 'column',
						gap: '16px',
						maxWidth: '480px',
					}}
				>
					<RBHBox
						onClick={handleOpenModal}
						style={{
							display: 'flex',
							color: Colors.violet,
							alignItems: 'center',
							gap: '4px',
							fontSize: '16px',
							cursor: 'pointer',
						}}
					>
						<EditOutlined translate={null} />
						<RBHText
							text='main.foodmenu.addmenu.modifiergroups.manage'
							style={{ color: Colors.violet, fontSize: '16px' }}
						/>
					</RBHBox>
					<RBHList
						dataSource={listItem}
						renderItem={(item: Item, index: number) => (
							<RBHBox
								style={{ display: 'flex', justifyContent: 'space-between' }}
							>
								<RBHText
									style={{
										color: Colors.font.primary.fakeBlack,
									}}
								>
									{item.menuModifierGroupName}
								</RBHText>
								<RBHBox style={{ marginRight: '16px' }}>
									<TagCount
										id={`modifier-list-tag-${index}`}
										count={item.menuModifierItems?.length ?? 0}
									/>
								</RBHBox>
							</RBHBox>
						)}
						dragable
						onSort={(sortedItems) => {
							setActiveModifierGroups(
								sortedItems.map((item: any) => {
									const { id, ...rest } = item;
									return rest;
								}),
							);
						}}
					/>
				</RBHBox>
			)}
		</>
	);
};
